<template>
  <!-- 案例详情 -->
  <xl-scrollbar>
  <div class="case-detail">
    
      <!-- 基本信息 -->
      <div class="base-info">
        <div class="title-box">
          <div class="title-icon"></div>
          <div class="title-text">{{ $t('design.orderDetail.baseInfo') || '基本信息'}}</div>
        </div>
        <div class="base-info-box">
          <div class="detail-left">
            <Tooth :type="type" :toothType="toothType" disabled :defaultValue="tooths"
              :bridgeInfo="info.bridgeInfo" :toothSignType="info.dentalNotation" :source="'caseDetail'"></Tooth>
            <div></div>
          </div>

          <div class="detail-right">
            <!-- <div class="detail-container">
              <div class="detail-row">
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.creditCard.paymentCaseCode') || '案例编号' }}</div>
                  <div class="detail-value">{{ orderID }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.targetTooth') || '目标牙位' }}</div>
                  <div class="detail-value">{{ toothName }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.designCost') || '设计费用' }}</div>
                  <div class="detail-value">{{ `${formatPrice(info.price)} ${info.currency}` }}</div>
                </div>
              </div>

              <div class="detail-row">
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.caseName') || '案例名称' }}</div>
                  <div class="detail-value">{{ info.orderName }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.isUrgent') || '是否加急' }}</div>
                  <div class="detail-value">{{ info.isUrgent ? $t('design.order.yes') : $t('design.order.no') }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('加急费用') }}</div>
                  <div class="detail-value">{{ '-' }}</div>
                </div>
              </div>

              <div class="detail-row">
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.designType') || '设计类型' }}</div>
                  <div class="detail-value">{{ info.typeName }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.leadTime') || '预计交付周期' }}</div>
                  <div class="detail-value">{{ $timeUnit(VueCookieNext.getCookie('lang'), info.deliveryUnit,
        info.deliveryDay) }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('增值税额') }}</div>
                  <div class="detail-value">{{ '-' }}</div>
                </div>
              </div>

              <div class="detail-row">
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.orderDetail.designProduct') || '设计产品' }}</div>
                  <div class="detail-value">{{ info.productName }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('design.createOn') || '创建时间' }}</div>
                  <div class="detail-value">{{ $convertUTCDateToLocalDate(info.createOn) }}</div>
                </div>
                <div class="detail-info">
                  <div class="detail-label">{{ $t('总费用') }}</div>
                  <div class="detail-value price-text">{{ '50 USD' }}</div>
                </div>
              </div>
            </div> -->
            <xl-form label-position="left" :label-width="labelWidth">
              <xl-row :gutter="20">
                <xl-col :span="8">
                  <xl-form-item prop="roleCode" :label="$t('design.creditCard.paymentCaseCode') || '案例编号'">
                    <xl-tooltip :content='orderID' placement="top">
                      <div class="form-value"><span>{{ orderID }}</span></div>
                    </xl-tooltip>
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8">
                  <xl-form-item prop="cnName" :label="$t('design.orderDetail.targetTooth') || '目标牙位'">
                    <!-- <xl-tooltip :content='toothName' placement="top"> -->
                      <div class="form-value">{{ toothName }}</div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8" v-if="showPayment">
                  <xl-form-item prop="cnName" :label="$t('design.case.designPrice') || '设计费用'">
                    <!-- <xl-tooltip :content='`${formatPrice(info.price)} ${info.currency}`' placement="top"> -->
                      <template #label>
                        <div class="taxes-label">
                          <xl-tooltip placement="top">
                            <img src="../../../assets/image/notice.svg" alt="" />
                            <template #content>
                                <span v-if="!hasPay || isCrashPay">{{ `${formatPrice(designPrice/info.goodsNum)} ${info.currency}` }}/{{ unitMap[info.chargeUnit]}} * {{info.goodsNum}}</span>
                                <div>
                                  <span v-if="!hasPay && info.points">{{$t('design.caseDetail.or') || '或'}}&nbsp;</span>
                                  <span v-if="(!hasPay || !isCrashPay) && info.points">{{ $t('design.point.pointNum', { point: designPoints/info.goodsNum }) }}/{{ unitMap[info.chargeUnit]}} * {{ info.goodsNum }}</span>
                                </div>
                            </template>
                          </xl-tooltip>
                          <span>{{ $t('design.case.designPrice') || '设计费用' }}</span>
                        </div>
                      </template>
                      <div class="form-value">
                        <span v-if="!hasPay || isCrashPay">{{ `${formatPrice(designPrice)} ${info.currency || ''}` }}</span>
                        <span v-if="!hasPay && info.points">/</span>
                        <span v-if="(!hasPay || !isCrashPay) && info.points">{{ designPoints ? $t('design.point.pointNum', { point: designPoints }) : '-'}}</span>
                      </div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>

                <xl-col :span="8">
                  <xl-form-item prop="enName" :label="$t('design.orderDetail.caseName') || '案例名称'">
                    <!-- <xl-tooltip :content='info.orderName' placement="top"> -->
                      <div class="form-value">{{ info.orderName }}</div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8">
                  <xl-form-item prop="frontRouter" :label="$t('design.orderDetail.isUrgent') || '是否加急'">
                    <!-- <xl-tooltip :content="info.isUrgent ? $t('design.order.yes') : $t('design.order.no')"
                      placement="top"> -->
                      <div class="form-value">{{ info.isUrgent ? $t('design.order.yes') : $t('design.order.no') }}
                      </div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8" v-if="showPayment">
                  <xl-form-item prop="frontRouter" :label="$t('design.orderDetail.urgentPrice') || '加急费用'">
                    <template #label>
                      <div class="taxes-label">
                        <xl-tooltip placement="top">
                          <img v-if="info.urgentPrice || info.urgentPoints" src="../../../assets/image/notice.svg" alt="" />
                          <template #content>
                              <span v-if="!hasPay || isCrashPay">{{ `${formatPrice(info.urgentPrice/info.goodsNum)} ${info.currency}` }}/{{ unitMap[info.chargeUnit]}} * {{info.goodsNum}}</span>
                              <div>
                                <span v-if="!hasPay && info.urgentPoints && info.points">{{$t('design.caseDetail.or') || '或'}}&nbsp;</span>
                                <span v-if="(!hasPay || !isCrashPay) && info.urgentPoints && info.points">{{ $t('design.point.pointNum', { point: info.urgentPoints/info.goodsNum }) }}/{{ unitMap[info.chargeUnit]}} * {{ info.goodsNum }}</span>
                              </div>
                          </template>
                        </xl-tooltip>
                        <span>{{ $t('design.orderDetail.urgentPrice') || '加急费用' }}</span>
                      </div>
                    </template>
                    <!-- <xl-tooltip :content="info.urgentPrice ? `${formatPrice(info.urgentPrice)} ${info.currency}` : '-'" placement="top"> -->
                      <div class="form-value">
                        <span v-if="!hasPay || isCrashPay">{{ info.urgentPrice ? `${formatPrice(info.urgentPrice)} ${info.currency}` : '-' }}</span>
                        <span v-if="!hasPay && info.urgentPoints && info.points">/</span>
                        <span v-if="(!hasPay || !isCrashPay) && info.urgentPoints && info.points">{{ info.urgentPoints ? $t('design.point.pointNum', { point: info.urgentPoints }) : '-' }}</span>
                      </div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>

                <xl-col :span="8">
                  <xl-form-item prop="details" :label="$t('design.orderDetail.designType') || '设计类型'">
                    <!-- <xl-tooltip :content='info.typeName' placement="top"> -->
                      <div class="form-value">{{ info.typeName }}</div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8">
                  <xl-form-item prop="details" :label="$t('design.orderDetail.leadTime') || '预计交付周期'">
                    <!-- <xl-tooltip :content="$timeUnit(VueCookieNext.getCookie('lang'), info.deliveryUnit,
            info.deliveryDay)" placement="top"> -->
                      <div class="form-value">{{ $timeUnit(VueCookieNext.getCookie('lang'), info.deliveryUnit,
            info.deliveryDay) }}</div>
                    <!-- </xl-tooltip> -->

                  </xl-form-item>
                </xl-col>
                <xl-col :span="8" v-if="showPayment">
                  <xl-form-item prop="details" :label="$t('design.orderDetail.valueAddedTaxAmount' || '增值税额')">
                    <template #label>
                      <div class="taxes-label">
                        <xl-tooltip :content="$t('design.case.localTaxRate', { taxRate: info.taxRate })" placement="top" :disabled="!info.taxRate || info.paymentWay === 'giftCard' || info.paymentWay === 'debitCard'">
                          <img v-if="info.taxRate && ( !info.paymentWay || info.paymentWay === 'cash')" src="../../../assets/image/notice.svg" alt="" />
                        </xl-tooltip>
                        <span>{{ $t('design.orderDetail.valueAddedTaxAmount') || '增值税额' }}</span>
                      </div>
                    </template>
                    <xl-tooltip>
                    </xl-tooltip>
                    <!-- <xl-tooltip content='-' placement="top"> -->
                      <div class="form-value">{{ taxPrice && ( !info.paymentWay || info.paymentWay === 'cash') ? `${formatPrice(taxPrice)} ${info.currency}` : '-' }}<span v-if="!hasPay && info.taxRate && info.points">/-</span></div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>

                <xl-col :span="8">
                  <xl-form-item prop="details" :label="$t('design.orderDetail.designProduct') || '设计产品'">
                    <!-- <xl-tooltip :content='info.productName' placement="top"> -->
                      <div class="form-value">{{ info.productName }}</div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8">
                  <xl-form-item prop="details" :label="$t('design.createOn') || '创建时间'">
                    <xl-tooltip :content='$convertUTCDateToLocalDate(info.createOn)' placement="top">
                      <div class="form-value">{{ $convertUTCDateToLocalDate(info.createOn) }}</div>
                    </xl-tooltip>
                  </xl-form-item>
                </xl-col>
                <xl-col :span="8" v-if="showPayment">
                  <xl-form-item prop="details" :label="$t('design.orderDetail.TotalCost') || '总费用'">
                    <template #label>
                      <div class="taxes-label">
                        <xl-tooltip :content="$t('design.caseDetail.totalPriceTip') || '设计费用+加急费用+增值税额'" placement="top">
                          <img src="../../../assets/image/notice.svg" alt="" />
                        </xl-tooltip>
                        <span>{{ $t('design.orderDetail.TotalCost') || '总费用' }}</span>
                      </div>
                    </template>
                    <!-- <xl-tooltip content='50 USD' placement="top"> -->
                      <div class="price-text form-value">
                        <span v-if="!hasPay || isCrashPay">{{ `${formatPrice(info.afterTaxPrice)} ${info.currency || ''}` }}</span>
                        <span v-if="!hasPay && info.points">/</span>
                        <span v-if="(!hasPay || !isCrashPay) && info.points">{{ info.points ? $t('design.point.pointNum', { point: info.points }) : '-' }}</span>
                      </div>
                    <!-- </xl-tooltip> -->
                  </xl-form-item>
                </xl-col>
              </xl-row>
            </xl-form>

            <div class="content-box">
              <div>{{ $t('design.orderDetail.designDescription') || '设计描述' }}</div>
              <div class="content-text">
                {{ info.productRemark }}
              </div>
            </div>
            <div class="content-box">
              <div>{{ $t('design.orderDetail.deliveryContent') || '交付内容' }}</div>
              <div class="content-text">
                {{ info.deliveryContent }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 设计需求 -->
      <designRequirement :infoList="info.preferences" :selectProduct="info.productConfig" :dentalNotation="info.dentalNotation" @viewImage="viewImage"></designRequirement>
      <!-- <div v-if="info?.preferences?.length && (info?.preferences[0]?.extra || info?.preferences[0]?.list)" class="design-requirement">
        <div class="design-text">
          <div class="title-box">
            <div class="title-icon"></div>
            <div class="title-text">{{ $t('design.orderDetail.designRequirement') || '设计需求' }}</div>
          </div>
          <div class="view-image" @click="viewImage">{{ $t('design.orderDetail.viewPreferenceImage') || '查看示意图'}}</div>
        </div>
        <designRequirement :infoList="info.preferences" :selectProduct="info.productConfig" :dentalNotation="info.dentalNotation"></designRequirement>
      </div> -->

      <!-- 其他需求 -->
      <div v-if="info.designContent" class="other-requirement">
        <div class="title-box">
          <div class="title-icon"></div>
          <div class="title-text">{{ $t('design.orderDetail.otherRequirement') || '其他需求'}}</div>
        </div>
        <div class="content-box requirement-box">
          <div class="content-text design-content requirement-content">
            {{ info.designContent }}
          </div>
        </div>
      </div>

    <designImageDialog v-model:visible="visible" :currentType="currentType" :productName="info.productName" :infoList="info.preferences"></designImageDialog>
    <!-- <xl-dialog v-model="visible" :title="$t('参数示意图')">
      <template #title>
        <div class="image-title">
          <div>产品名称{{ $t('design.orderDetail.imageDialogTitle') || '参数示意图' }}</div>
        </div>
      </template>
      <typeIndex :currentType="currentType"></typeIndex>
    </xl-dialog> -->
  </div>
  </xl-scrollbar>
</template>
<script setup>
import { ref, computed, defineProps, watch, nextTick, onMounted } from 'vue';
import {
  XlScrollbar,
  XlForm,
  XlFormItem,
  XlRow,
  XlCol,
  XlTooltip,
  XlDialog
} from "@shining3d/ui-components";
import Tooth from "../../case/components/tooth.vue";
import typeFImage from '../../preference/components/typeF/typeFImage.vue'
import typeIndex from '../../preference/components/typeIndex.vue'
import designRequirement from '../../../components/designRequirement.vue'
import designImageDialog from '../../../components/designImageDialog.vue'
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang("@shining3d/xl-design-order");
import { toothNameMap, unitMap } from '../../case/const';
import { timeMap, preferProductMap } from '../../../common/enum';
import { $convertUTCDateToLocalDate, formatPrice, $transToothNumber, $timeUnit, $getCdnUrl } from '../../../utils/common.js';
import { VueCookieNext } from 'vue-cookie-next';
// import '@shining3d/xl-element-plus/dist/index.css';

const props = defineProps({
  platform: {
    type: String,
    default: 'dental'
  },
  orgID: {
    type: String
  },
  orderID: {
    type: String
  },
  info: {
    type: Object,
    default: () => ({})
  }
});

const showPayment = computed(()=> {
  return props.platform !== 'designerService'
});

const type = ref(); // 牙号类型 toothPositionSelector
const tooths = ref([]);
const toothName = ref('');
const toothType = ref('');
// 税额
const taxPrice = ref();
// 设计费用（不包含加急费用）
const designPrice = ref();
const designPoints = ref(0);
// 图片预览列表
const srcList = ref([]);
// 查看示意图
const visible = ref( false );
const showImagePreview = ref( false );
const viewImage = () => {
  visible.value = true;
}
const labelWidth = computed(() => VueCookieNext.getCookie('lang') === 'zh-cn' ? 110 : 158)
// 当前订单的产品类型
const currentType = ref()
const hasPay = ref(false);
const isCrashPay = ref(false);

watch(() => props.info, (val) => {
  tooths.value = val.tooths?.split(',') || [];
  toothName.value = tooths.value.map(item => {
    let showName = '';
    if (toothNameMap[item]) {
      showName = toothNameMap[item];
    } else {
      showName = $transToothNumber(Number(item), val.dentalNotation);
    }
    return showName;
  }).join('、');
  const toothPositionSelector = val.toothPositionSelector;
  if ( toothPositionSelector === 'selectorPerPiece') {
      // 普通颗
      type.value = 'perPiece';
      toothType.value = 'repair';
  } else if ( toothPositionSelector === 'selectorPerAbutmentPiece') {
      //  基台颗
      type.value = 'perPiece';
      toothType.value = 'plant';
  } else if ( toothPositionSelector === 'selectorPerHole' ) {
      type.value = 'perHole';
      toothType.value = 'hole';
  } else if ( toothPositionSelector === 'selectorPerCase') {
      type.value = 'perCase';
  } else if ( toothPositionSelector === 'selectorPerJaw' ) {
      type.value = 'perJaw';
  }

  taxPrice.value = (val.afterTaxPrice - val.price) || 0;
  designPrice.value = (val.price - val.urgentPrice) || 0;
  currentType.value = preferProductMap[val.productConfig]?.imageType;
  // 设计积分 = 总积分 - 加急积分
  designPoints.value = val.urgentPoints ? val.points - val.urgentPoints : val.points;

  // 是否有支付方式 及是否现金支付
  hasPay.value = Boolean(val.paymentWay);
  isCrashPay.value = val.paymentWay && val.paymentWay === 'cash';

}, { immediate: true, deep: true });

// onMounted(() => {
//   currentType.value = preferProductMap[props.info.productConfig]?.imageType

// })
</script>
<style lang="scss" scoped>
.case-detail {
  // display: flex;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  font-family: "Alibaba PuHuiTi 2.0";
  .base-info{
    margin-bottom: 12px;
  }
  .base-info-box {
    display: flex;
  }

  .detail-left {
    width: 230px;
    height: 400px;
    min-width: 230px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-right: 1px dashed #e0e4ea;
    // padding-top: 24px;
    // overflow-y: auto;

    .el-scrollbar {
      width: 100%;
    }

    :deep(.all-wrap .img) {
      width: 173px !important;
      height: 365px !important;
    }

    :deep(.xl-tooth) {
      svg {
        width: 173px !important;
      }

      .xl-sign-type {
        position: absolute;
        top: 47%;
        left: 50%;
        transform: translateX(-50%);
      }

      .half-content.down-half {
        bottom: 30% !important;
      }

      .half-content.up-half {
        top: 28% !important;
      }
    }
  }

  .detail-right {
    // flex: 1;
    width: 100%;
    // overflow-x: scroll;
    padding: 24px 0 16px 24px;
    box-sizing: border-box;

    .el-form {
      margin-bottom: 16px;
    }
    .taxes-label{
      display: flex;
      align-items: center;
      img{
        margin-right: 2px;
      }
    }
  }

  .price-text {
    font-size: 16px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    color: #ff7e55 !important;
  }

  .content-box {
    padding: 16px;
    border-radius: 6px;
    margin-bottom: 16px;
    background: #f7f8fa;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #a5acbe;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }

  .content-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-top: 8px;
    color: #42526e !important;
  }

  .design-content {
    word-wrap: break-word;
  }

  .require-text {
    margin-top: 0 !important;
  }

  .require-content {
    padding: 0 !important;
    display: flex;
    margin: 0 0 12px 0 !important;
    background: #ffffff;
  }

  .require-title {
    width: 120px;
    min-width: 120px;
  }

  :deep(.el-form-item__label) {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #737E99;
    width: 120px;
  }

  :deep(.el-form-item__content) {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #42526e;
    height: fit-content;
    // min-width: max-content;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :deep(.el-form-item) {
    height: 22px !important;
    margin-bottom: 8px !important;
  }

  :deep(.el-scrollbar__view) {
    overflow-x: hidden;
  }

  .detail-container {
    display: flex;
    flex-direction: column;

    .detail-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
    }

    .detail-info {
      width: 410px;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;

      .detail-label {
        width: 110px;
        min-width: 110px;
        color: #737E99;
      }

      .detail-value {
        // max-width: 290px;
        color: #42526E;
      }
    }
  }

  .title-box {
    display: flex;
    align-items: center;

    .title-icon {
      width: 5px;
      height: 16px;
      background: #5587FF;
      margin-right: 8px;
    }

    .title-text {
      font-size: 16px;
      font-weight: 700;
      line-height: 22.4px;
      color: #2C364E;
    }
  }

  .form-value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .requirement-box{
    box-sizing: border-box;
    margin-top: 10px;
    padding: 12px 16px !important;
    min-height: 68px;
  }
  .requirement-content{
    margin-top: 0 !important;
  }
  .design-requirement{
    margin-bottom: 16px;
    .view-image{
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #5587FF;
      cursor: pointer;
    }
  }
  .design-text{
    display: flex;
    justify-content: space-between;
  }
  .image-title{
      color: $color-n10;
      font-size: 18px;
      font-family: $font-family65;
      font-weight: bold;
  }
}
</style>
